package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.ActiveCombat
import fr.manyverse.app.domain.repository.CombatRepository
import kotlinx.coroutines.flow.Flow

/**
 * Observe le combat actif d'une table en temps réel.
 * Émet le combat tant qu'il est actif et que l'utilisateur est concerné
 * (créateur ou participant), puis null quand il est arrêté.
 */
class ObserveActiveCombatUseCase(
    private val combatRepository: CombatRepository
) {
    operator fun invoke(
        tableId: String,
        currentUserId: String
    ): Flow<ActiveCombat?> = combatRepository.observeActiveCombat(tableId, currentUserId)
}
